export default __webpack_public_path__ + "static/media/plus.b16a999e.svg";